export default __webpack_public_path__ + "static/media/image.divor-automations-pvt-ltd.21a07451.png";